import { viewPath } from "../navigate.ts";
import { tenantHome } from "../routes.ts";
import { DEMO_TENANT } from "./replay.ts";

export const DEMO_HOME = tenantHome(DEMO_TENANT);

export const demoHref = (view: string): string => viewPath(DEMO_TENANT, view);
